/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".divider[_ngcontent-%COMP%]{border-bottom:1px solid #f0f0f0}@media screen and (max-width:525px){.divider[_ngcontent-%COMP%]{width:100%}}@media screen and (min-width:526px){.divider[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1}}"];
export { styles as styles };
//# sourceMappingURL=live-class-state-view-title.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/live-class-state-view-title/live-class-state-view-title.component.scss.shim.ngstyle.js
// module id = 1540
// module chunks = 27 28 29